import React from "react";
import { Col, Container, Row } from "@insightfulscience/atomic-react/Grid";
import Section from "@insightfulscience/atomic-react/Section";
import Block from "@insightfulscience/atomic-react/Block";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import ProductsTab from "@insightfulscience/atomic-react/ProductsTab";
import HeroTitle from "@insightfulscience/atomic-react/Hero/Title";
import Hero from "@insightfulscience/atomic-react/Hero";
import PricingSection from "@insightfulscience/atomic-react/r1/molecules/PricingSection";
import CardPrice from "@insightfulscience/atomic-react/CardPrice";
import CardPriceHead from "@insightfulscience/atomic-react/CardPrice/Head";
import CardPriceTitle from "@insightfulscience/atomic-react/CardPrice/Title";
import CardPriceBody from "@insightfulscience/atomic-react/CardPrice/Body";
import CardPriceList, { CardPriceListItem } from "@insightfulscience/atomic-react/CardPrice/List";
import CardPriceDescription from "@insightfulscience/atomic-react/CardPrice/Description";
import CardPriceAction from "@insightfulscience/atomic-react/CardPrice/Action";
import CardPriceButtonLink from "@insightfulscience/atomic-react/CardPrice/ButtonLink";
import LandingSimpleSection from "@insightfulscience/atomic-react/LandingElement/SimpleSection";
import CardPriceTitleV2 from "@insightfulscience/atomic-react/CardPrice/TitleV2";
import CardPriceOne from "@insightfulscience/atomic-react/CardPrice/One";
import Line from "@insightfulscience/atomic-react/Line";
import { useLocale } from "@insightfulscience/smart-react/i18";
import PageMeta from "@insightfulscience/smart-react/PageMeta";
import Html from "@insightfulscience/smart-react/Html";
import Button from "@insightfulscience/atomic-react/Button";
import NextLink from "@insightfulscience/smart-react/NextLink";
import CardList from "@insightfulscience/atomic-react/CardPrice/ListV2";
import SiteLayout from "../../SiteLayout";
import routes from "../../routes";

const HowToBuyPage = () => {
	const [t] = useLocale("pricing");
	return (
		<SiteLayout isWrapper={false}>
			<PageMeta title={t("META.TITLE")} description={t("META.DESCRIPTION")}>
				<PageMeta.Canonical href={t("META.CANONICAL")} />
			</PageMeta>
			<Hero utility={{ bgColor: "white" }}>
				<HeroTitle>{t("HERO_TITLE")}</HeroTitle>
			</Hero>
			<Section utility={{ bgColor: "4" }}>
				<Row utility={{ bgColor: "white" }} spacing={{ pt: 9 }}>
					<Col>
						<Container>
							<Row>
								<Col md="auto">
									<ProductsTab
										logoIcon="/images/geneious/logo/icon-prime.svg"
										borderColor="3"
										title={t("TABS.TAB_1.TITLE")}
										description={t("TABS.TAB_1.DESCRIPTION")}
										active
										data-qa-selector="geneious-prime-tab"
									/>
								</Col>
								<Col md="auto">
									<NextLink
										href={routes.pricingBiologics}
										Component={ProductsTab}
										logoIcon="/images/geneious/logo/icon-biologics.svg"
										borderColor="dotmatics-7"
										title={t("TABS.TAB_2.TITLE")}
										description={t("TABS.TAB_2.DESCRIPTION")}
										data-qa-selector="geneious-biologics-tab"
									/>
								</Col>
							</Row>
						</Container>
					</Col>
				</Row>
			</Section>
			<PricingSection utility={{ bgColor: "4" }}>
				<PricingSection.Header title={t("FIRST_PRICING_SECTION.TITLE")}>
					{t("FIRST_PRICING_SECTION.DESCRIPTION")}
				</PricingSection.Header>
				<PricingSection.Body lgCellWidth={12}>
					<PricingSection.Body.Item>
						<CardPrice className="mb-10">
							<CardPriceHead>
								<CardPriceTitle>{t("FIRST_PRICING_SECTION.ACADEMIC.TITLE")}</CardPriceTitle>
							</CardPriceHead>
							<CardPriceBody>
								<CardPriceList
									colOne={t("FIRST_PRICING_SECTION.ACADEMIC.COL_ONE")}
									colTwo={t("FIRST_PRICING_SECTION.ACADEMIC.COL_TWO")}
								>
									<CardPriceListItem amount={2} price="$1,280" />
									<CardPriceListItem amount={5} price="$3,200" />
									<CardPriceListItem amount={10} price="$6,400" />
								</CardPriceList>
								<CardPriceDescription>
									{t("FIRST_PRICING_SECTION.ACADEMIC.ADDITIONAL")}
								</CardPriceDescription>
								<CardPriceAction>
									<CardPriceButtonLink
										href={`${routes.purchase.configSubscription}?planCode=gn_group_academic_yearly_isul`}
										data-qa-selector="buy-group-academic-btn"
									>
										{t("FIRST_PRICING_SECTION.ACADEMIC.BUTTON")}
									</CardPriceButtonLink>
								</CardPriceAction>
							</CardPriceBody>
						</CardPrice>
					</PricingSection.Body.Item>
					<PricingSection.Body.Item>
						<CardPrice className="mb-10">
							<CardPriceHead>
								<CardPriceTitle>{t("FIRST_PRICING_SECTION.CORPORATE.TITLE")}</CardPriceTitle>
							</CardPriceHead>
							<CardPriceBody>
								<CardPriceList
									colOne={t("FIRST_PRICING_SECTION.CORPORATE.COL_ONE")}
									colTwo={t("FIRST_PRICING_SECTION.CORPORATE.COL_TWO")}
								>
									<CardPriceListItem amount={2} price="$4,500" />
									<CardPriceListItem amount={5} price="$11,250" />
									<CardPriceListItem amount={10} price="$22,500" />
								</CardPriceList>
								<CardPriceDescription>
									{t("FIRST_PRICING_SECTION.CORPORATE.ADDITIONAL")}
								</CardPriceDescription>
								<CardPriceAction>
									<CardPriceButtonLink
										href={`${routes.purchase.configSubscription}?planCode=gn_group_corporate_yearly_isul`}
										data-qa-selector="buy-group-corporate-btn"
									>
										{t("FIRST_PRICING_SECTION.CORPORATE.BUTTON")}
									</CardPriceButtonLink>
								</CardPriceAction>
							</CardPriceBody>
						</CardPrice>
					</PricingSection.Body.Item>
					<PricingSection.Body.Item>
						<CardPrice className="mb-10">
							<CardPriceHead>
								<CardPriceTitle>{t("FIRST_PRICING_SECTION.ENTERPRISE.TITLE")}</CardPriceTitle>
							</CardPriceHead>
							<CardPriceBody>
								<CardList.Title>{t("FIRST_PRICING_SECTION.ENTERPRISE.LIST_TITLE")}</CardList.Title>
								<CardList>
									<CardList.Item>{t("FIRST_PRICING_SECTION.ENTERPRISE.LIST_ITEM_1")}</CardList.Item>
									<CardList.Item>{t("FIRST_PRICING_SECTION.ENTERPRISE.LIST_ITEM_2")}</CardList.Item>
									<CardList.Item>{t("FIRST_PRICING_SECTION.ENTERPRISE.LIST_ITEM_3")}</CardList.Item>
									<CardList.Item>{t("FIRST_PRICING_SECTION.ENTERPRISE.LIST_ITEM_4")}</CardList.Item>
								</CardList>
								<CardPriceAction>
									<CardPriceButtonLink
										href={routes.enterprise}
										data-qa-selector="buy-group-enterprise-btn"
									>
										{t("FIRST_PRICING_SECTION.ENTERPRISE.BUTTON")}
									</CardPriceButtonLink>
								</CardPriceAction>
							</CardPriceBody>
						</CardPrice>
					</PricingSection.Body.Item>
				</PricingSection.Body>
				<PricingSection.Footer lgCellWidth={12}>
					<PricingSection.Footer.Title>
						{t("FIRST_PRICING_SECTION.FOOTER.ROW_1")}
					</PricingSection.Footer.Title>
					<PricingSection.Footer.List>
						<PricingSection.Footer.List.Item>
							<span className="text-color-3">{t("FIRST_PRICING_SECTION.FOOTER.NEW")}!</span>{" "}
							<Html Tag="span">
								{t("FIRST_PRICING_SECTION.FOOTER.ROW_2", {
									link: routes.external.cloud,
								})}
							</Html>
						</PricingSection.Footer.List.Item>
						<PricingSection.Footer.List.Item>
							<span className="text-color-3">{t("FIRST_PRICING_SECTION.FOOTER.NEW")}!</span>{" "}
							{t("FIRST_PRICING_SECTION.FOOTER.ROW_3")}
						</PricingSection.Footer.List.Item>
						<PricingSection.Footer.List.Item>
							<span className="text-color-3">{t("FIRST_PRICING_SECTION.FOOTER.NEW")}!</span>{" "}
							{t("FIRST_PRICING_SECTION.FOOTER.ROW_4")}
						</PricingSection.Footer.List.Item>
						<PricingSection.Footer.List.Item>
							{t("FIRST_PRICING_SECTION.FOOTER.ROW_5")}
						</PricingSection.Footer.List.Item>
						<PricingSection.Footer.List.Item>
							{t("FIRST_PRICING_SECTION.FOOTER.ROW_6")}
						</PricingSection.Footer.List.Item>
						<PricingSection.Footer.List.Item>
							{t("FIRST_PRICING_SECTION.FOOTER.ROW_7")}
						</PricingSection.Footer.List.Item>
						<PricingSection.Footer.List.Item>
							{t("FIRST_PRICING_SECTION.FOOTER.ROW_8")}
						</PricingSection.Footer.List.Item>
						<PricingSection.Footer.List.Item>
							{t("FIRST_PRICING_SECTION.FOOTER.ROW_9")}
						</PricingSection.Footer.List.Item>
						<PricingSection.Footer.List.Item>
							{t("FIRST_PRICING_SECTION.FOOTER.ROW_10")}
						</PricingSection.Footer.List.Item>
						<PricingSection.Footer.List.Item>
							{t("FIRST_PRICING_SECTION.FOOTER.ROW_11")}
						</PricingSection.Footer.List.Item>
						<PricingSection.Footer.List.Item>
							<Html Tag="span">
								{t("FIRST_PRICING_SECTION.FOOTER.ROW_12", {
									link: routes.academy,
								})}
							</Html>
						</PricingSection.Footer.List.Item>
					</PricingSection.Footer.List>
					<PricingSection.Footer.Description sx={{ textAlign: "center", fontColor: "black--35" }}>
						<Html Tag="span">
							{t("FIRST_PRICING_SECTION.FOOTER.DESCRIPTION", {
								link: "https://assets.geneious.com/legal/terms-of-service.pdf",
							})}
						</Html>
					</PricingSection.Footer.Description>
				</PricingSection.Footer>
			</PricingSection>
			<Container utility={{ bgColor: "4" }} isFluid>
				<Row center>
					<Col sm={6}>
						<Line utility={{ border: { bottom: { width: 1, color: "black--15" } } }} />
					</Col>
				</Row>
			</Container>
			<PricingSection utility={{ bgColor: "4" }}>
				<PricingSection.Header title="Personal Subscription">
					{t("SECOND_PRICING_SECTION.TITLE")}
				</PricingSection.Header>
				<PricingSection.Body lgCellWidth={12}>
					<PricingSection.Body.Item>
						<CardPrice className="mb-10">
							<CardPriceHead>
								<CardPriceTitleV2>{t("SECOND_PRICING_SECTION.STUDENT.TITLE")}</CardPriceTitleV2>
							</CardPriceHead>
							<CardPriceBody>
								<CardPriceOne price="$200" period={t("SECOND_PRICING_SECTION.STUDENT.PERIOD")}>
									<Paragraph
										sx={{ textAlign: "center", fontSize: "s" }}
										spacing={{ mt: 6, mb: 13 }}
									>
										{t("SECOND_PRICING_SECTION.STUDENT.DESCRIPTION")}
									</Paragraph>
								</CardPriceOne>
								<CardPriceAction>
									<CardPriceButtonLink
										href={`${routes.purchase.configSubscription}?planCode=gn_personal_student_yearly_isul`}
										data-qa-selector="buy-personal-student-btn"
									>
										{t("SECOND_PRICING_SECTION.STUDENT.BUTTON")}
									</CardPriceButtonLink>
								</CardPriceAction>
							</CardPriceBody>
						</CardPrice>
					</PricingSection.Body.Item>
					<PricingSection.Body.Item>
						<CardPrice className="mb-10">
							<CardPriceHead>
								<CardPriceTitleV2>{t("SECOND_PRICING_SECTION.ACADEMIC.TITLE")}</CardPriceTitleV2>
							</CardPriceHead>
							<CardPriceBody>
								<CardPriceOne price="$595" period={t("SECOND_PRICING_SECTION.ACADEMIC.PERIOD")}>
									<Paragraph sx={{ textAlign: "center", fontSize: "s" }} spacing={{ mt: 6 }}>
										{t("SECOND_PRICING_SECTION.ACADEMIC.DESCRIPTION")}
									</Paragraph>
								</CardPriceOne>
								<CardPriceAction>
									<CardPriceButtonLink
										href={`${routes.purchase.configSubscription}?planCode=gn_personal_academic_yearly_isul`}
										data-qa-selector="buy-personal-academic-btn"
									>
										{t("SECOND_PRICING_SECTION.ACADEMIC.BUTTON")}
									</CardPriceButtonLink>
								</CardPriceAction>
							</CardPriceBody>
						</CardPrice>
					</PricingSection.Body.Item>
					<PricingSection.Body.Item>
						<CardPrice className="mb-10">
							<CardPriceHead>
								<CardPriceTitleV2>{t("SECOND_PRICING_SECTION.CORPORATE.TITLE")}</CardPriceTitleV2>
							</CardPriceHead>
							<CardPriceBody>
								<CardPriceOne price="$1,950" period={t("SECOND_PRICING_SECTION.CORPORATE.PERIOD")}>
									<Paragraph
										sx={{ textAlign: "center", fontSize: "s" }}
										spacing={{ mt: 6, mb: 13 }}
									>
										{t("SECOND_PRICING_SECTION.CORPORATE.DESCRIPTION")}
									</Paragraph>
								</CardPriceOne>
								<CardPriceAction>
									<CardPriceButtonLink
										href={`${routes.purchase.configSubscription}?planCode=gn_personal_corporate_yearly_isul`}
										data-qa-selector="buy-personal-corporate-btn"
									>
										{t("SECOND_PRICING_SECTION.CORPORATE.BUTTON")}
									</CardPriceButtonLink>
								</CardPriceAction>
							</CardPriceBody>
						</CardPrice>
					</PricingSection.Body.Item>
				</PricingSection.Body>
				<PricingSection.Footer lgCellWidth={12}>
					<PricingSection.Footer.Title>
						{t("SECOND_PRICING_SECTION.FOOTER.ROW_1")}
					</PricingSection.Footer.Title>
					<PricingSection.Footer.List>
						<PricingSection.Footer.List.Item>
							<Html Tag="span">
								{t("SECOND_PRICING_SECTION.FOOTER.ROW_7", {
									link: routes.external.cloud,
								})}
							</Html>
						</PricingSection.Footer.List.Item>
						<PricingSection.Footer.List.Item>
							{t("SECOND_PRICING_SECTION.FOOTER.ROW_8")}
						</PricingSection.Footer.List.Item>
						<PricingSection.Footer.List.Item>
							{t("SECOND_PRICING_SECTION.FOOTER.ROW_2")}
						</PricingSection.Footer.List.Item>
						<PricingSection.Footer.List.Item>
							{t("SECOND_PRICING_SECTION.FOOTER.ROW_3")}
						</PricingSection.Footer.List.Item>
						<PricingSection.Footer.List.Item>
							{t("SECOND_PRICING_SECTION.FOOTER.ROW_4")}
						</PricingSection.Footer.List.Item>
						<PricingSection.Footer.List.Item>
							{t("SECOND_PRICING_SECTION.FOOTER.ROW_5")}
						</PricingSection.Footer.List.Item>
						<PricingSection.Footer.List.Item>
							<Html Tag="span">
								{t("SECOND_PRICING_SECTION.FOOTER.ROW_6", {
									link: routes.academy,
								})}
							</Html>
						</PricingSection.Footer.List.Item>
					</PricingSection.Footer.List>
					<PricingSection.Footer.Description sx={{ textAlign: "center", fontColor: "black--35" }}>
						<Html Tag="span">
							{t("SECOND_PRICING_SECTION.FOOTER.DESCRIPTION", {
								link: "https://assets.geneious.com/legal/terms-of-service.pdf",
							})}
						</Html>
					</PricingSection.Footer.Description>
				</PricingSection.Footer>
			</PricingSection>
			<Container utility={{ bgColor: "4" }} isFluid>
				<Row center>
					<Col sm={6}>
						<Line utility={{ border: { bottom: { width: 1, color: "black--15" } } }} />
					</Col>
				</Row>
			</Container>
			<LandingSimpleSection bgColor="4" isBorderNone>
				<LandingSimpleSection.TitleV2>{t("COURSE_LICENSES.TITLE")}</LandingSimpleSection.TitleV2>
				<LandingSimpleSection.DescriptionV2>
					{t("COURSE_LICENSES.FIRST_LINE")}
					<br />
					{t("COURSE_LICENSES.SECOND_LINE")}
				</LandingSimpleSection.DescriptionV2>
				<LandingSimpleSection.Action
					href={routes.courseLicenses}
					ActionComponent={Button.Link}
					styleType="primary"
					isOutline
				>
					{t("COURSE_LICENSES.BUTTON_TEXT")}
				</LandingSimpleSection.Action>
			</LandingSimpleSection>
			<Container utility={{ bgColor: "4" }} isFluid>
				<Row center>
					<Col sm={6}>
						<Line utility={{ border: { bottom: { width: 1, color: "black--15" } } }} />
					</Col>
				</Row>
			</Container>
			<LandingSimpleSection bgColor="4" isBorderNone>
				<LandingSimpleSection.TitleV2 spacing={{ mb: 15 }}>
					{t("FAQ_SECTION.TITLE")}
				</LandingSimpleSection.TitleV2>

				<LandingSimpleSection.Body>
					<Row mx>
						<Col md={4}>
							<Block spacing={{ mb: 4 }}>
								<Paragraph Tag="div" sx={{ fontSize: "l", fontWeight: "bold" }}>
									{t("FAQ_SECTION.FIRST_QUESTION.QUESTION")}
								</Paragraph>
								<Paragraph Tag="div" spacing={{ mt: 5 }}>
									{t("FAQ_SECTION.FIRST_QUESTION.ANSWER_1")}
								</Paragraph>
								<Paragraph Tag="div" spacing={{ mt: 5 }}>
									<Html Tag="span">
										{t("FAQ_SECTION.FIRST_QUESTION.ANSWER_2", {
											link: "/account",
										})}
									</Html>
								</Paragraph>
								<Paragraph Tag="div" spacing={{ mt: 5 }}>
									<Html Tag="span">
										{t("FAQ_SECTION.FIRST_QUESTION.ANSWER_3", {
											link: routes.contact.index,
										})}
									</Html>
								</Paragraph>
							</Block>
						</Col>
						<Col md={4}>
							<Block spacing={{ mb: 4 }}>
								<Paragraph Tag="div" sx={{ fontSize: "l", fontWeight: "bold" }}>
									{t("FAQ_SECTION.SECOND_QUESTION.QUESTION")}
								</Paragraph>
								<Paragraph Tag="div" spacing={{ mt: 5 }}>
									{t("FAQ_SECTION.SECOND_QUESTION.ANSWER_1")}
								</Paragraph>
								<Paragraph Tag="div" spacing={{ mt: 5 }}>
									<Html Tag="span">
										{t("FAQ_SECTION.SECOND_QUESTION.ANSWER_2", {
											link: routes.contact.index,
										})}
									</Html>
								</Paragraph>
							</Block>
						</Col>
						<Col md={4}>
							<Block spacing={{ mb: 4 }}>
								<Paragraph Tag="div" sx={{ fontSize: "l", fontWeight: "bold" }}>
									{t("FAQ_SECTION.THIRD_QUESTION.QUESTION")}
								</Paragraph>
								<Paragraph Tag="div" spacing={{ mt: 5 }}>
									{t("FAQ_SECTION.THIRD_QUESTION.ANSWER_1")}
								</Paragraph>
							</Block>
						</Col>
					</Row>
					<Row mx spacing={{ mt: 5 }}>
						<Col md={4}>
							<Block spacing={{ mb: 4 }}>
								<Paragraph Tag="div" sx={{ fontSize: "l", fontWeight: "bold" }}>
									{t("FAQ_SECTION.FOURTH_QUESTION.QUESTION")}
								</Paragraph>
								<Paragraph Tag="div" spacing={{ mt: 5 }}>
									{t("FAQ_SECTION.FOURTH_QUESTION.ANSWER_1")}
								</Paragraph>
							</Block>
						</Col>
						<Col md={4}>
							<Block spacing={{ mb: 4 }}>
								<Paragraph Tag="div" sx={{ fontSize: "l", fontWeight: "bold" }}>
									{t("FAQ_SECTION.FIFTH_QUESTION.QUESTION")}
								</Paragraph>
								<Paragraph Tag="div" spacing={{ mt: 5 }}>
									<Html Tag="span">
										{t("FAQ_SECTION.FIFTH_QUESTION.ANSWER_1", {
											link: routes.external.security,
										})}
									</Html>
								</Paragraph>
							</Block>
						</Col>
						<Col md={4}>
							<Block spacing={{ mb: 4 }}>
								<Paragraph Tag="div" sx={{ fontSize: "l", fontWeight: "bold" }}>
									{t("FAQ_SECTION.SIXTH_QUESTION.QUESTION")}
								</Paragraph>
								<Paragraph Tag="div" spacing={{ mt: 5 }}>
									<Html>
										{t("FAQ_SECTION.SIXTH_QUESTION.ANSWER_1", {
											link: routes.contact.index,
										})}
									</Html>
								</Paragraph>
							</Block>
						</Col>
					</Row>
				</LandingSimpleSection.Body>
			</LandingSimpleSection>
		</SiteLayout>
	);
};

export default HowToBuyPage;
